import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {AdSettingsEdit} from '../components/AdSettingsEdit';

interface OpenAdSettingsEditDialogProps {
  vehicleId: string;
  isDisabled: boolean;
}

export function openAdSettingsEditDialog(props: OpenAdSettingsEditDialogProps) {
  openDialog(<AdSettingsEdit {...props} />, {
    title: i18n.t('entity.vehicle.labels.listingAttributes'),
  });
}
